import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/Service/common.service";
import { CompanySettingService } from "src/app/Service/company-setting.service";

//decoratore
@Component({
  selector: 'app-footer-subscribe',
  templateUrl: '../subscribe/subscribe.component.html',
})

export class SubscribeComponent implements OnInit {
  loader: boolean = false;

  form = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(60),
      Validators.pattern(/^(?!.*?[^aeiou]{5})(?!.*?[aeiou]{3})[a-zA-Z ]*$/),
    ],),
    email: new FormControl('', [Validators.required, Validators.email])
  });

  CompanySetting = CompanySettingService;
  constructor(private readonly commonService: CommonService, private readonly toastr: ToastrService) { }

  onBlur(value: any) {
    console.log(this.form.controls['username'].errors);
  }

  ngOnInit() {
  }

  onSubmit() {
    if (this.form.invalid) {
      this.toastr.warning('Please fill form correctly.');
      return;
    }
    const formData = this.form.value;
    // this.loader = true;
    const requestModel = {
      "UserRQ": {
        "Authentication": {
          "AuthenticationKey": "AB82D7A7-A4E4-4F9D-B950-9A6C9EC1C612",
          "CompanyId": this.CompanySetting.CompanyCode,
          "IPAddress": "",
          "ChannelCode": this.CompanySetting.Channel,
          "DomainUrl": ""
        },
        "RequestHeader": {
          "Method": "SubscribeNewsLetter",
          "Culture": "en"
        },
        "RequestBody": {
          "UserDetails": {
            "ClientId": 0,
            "FirstName": `${formData.username}`,
            "Email": `${formData.email}`,
            "PageContent": "",
          }
        }
      }
    }
    this.commonService.SubscribeNewsLetter(requestModel).subscribe(
      response => {
        this.loader = false;
        this.toastr.success("Subscription successful!")
        this.form.reset();
      },
      error => {
        this.loader = false;
        this.toastr.error("Please try again later!")
      }
    )
  }
}